import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaEdit, FaTrash, FaSearch } from "react-icons/fa";
import AlertModal from "../../Components/AlertModal";
import { Link } from "react-router-dom";
import CustomerModal from "./CustomerModal";
import apiClient from "../../AppClient";

const CustomersListScreen = () => {
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const rowsPerPage = 15;

  const fetchCustomers = () => {
    setLoading(true);
    apiClient
      .get("/customers/")
      .then((response) => {
        setCustomers(response.data);
        setFilteredCustomers(response.data);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          setError(error.response.data.detail);
          setLoading(false);
        } else {
          setError("حدث خطأ اثناء الاتصال بالسيرفر");
          setLoading(false);
        }
      });
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  useEffect(() => {
    const filtered = customers.filter(customer =>
      customer.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      customer.phone?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      customer.total_purchase_value.toString().includes(searchTerm)
    );
    setFilteredCustomers(filtered);
    setCurrentPage(1);
  }, [searchTerm, customers]);

  const handleAdd = () => {
    setModalMode("add");
    setSelectedCustomer(null);
    setShowModal(true);
  };

  const handleEdit = (customer) => {
    setModalMode("edit");
    setSelectedCustomer(customer);
    setShowModal(true);
  };

  const handleDelete = (id) => {
    setLoading(true);
    apiClient
      .delete(`/customers/${id}/delete/`)
      .then((response) => {
        fetchCustomers();
        setError(null);
      })
      .catch((error) => {
        if (error.response) {
          setError(error.response.data.detail);
          setLoading(false);
        } else {
          setError("حدث خطأ اثناء الاتصال بالسيرفر");
          setLoading(false);
        }
      });
  };

  // Pagination logic
  const totalPages = Math.ceil(filteredCustomers.length / rowsPerPage);
  const paginatedCustomers = filteredCustomers.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between flex-wrap mb-3">
        {error && <div className="alert alert-danger">{error}</div>}
        <h2 className="mb-3" style={{ color: "darkgreen" }}>قائمة الزبائن</h2>
        <button 
          className="btn" 
          onClick={handleAdd}
          style={{ backgroundColor: "darkgreen", color: "white" }}
        >
          إضافة زبون جديد
        </button>
      </div>

      {/* Search Bar */}
      <div className="mb-3" style={{ maxWidth: "400px" }}>
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            placeholder="ابحث عن زبون..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ borderColor: "darkgreen" }}
          />
          <span 
            className="input-group-text" 
            style={{ backgroundColor: "darkgreen", color: "white" }}
          >
            <FaSearch />
          </span>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered text-center">
          <thead style={{ backgroundColor: "darkgreen", color: "white" }}>
            <tr>
              <th>اسم الزبون</th>
              <th className="d-none d-md-table-cell">رقم الهاتف</th>
              <th>تاريخ آخر شراء</th>
              <th className="d-none d-md-table-cell">مجموع قيمة المشتريات</th>
              <th>إجراءات</th>
            </tr>
          </thead>
          <tbody>
            {paginatedCustomers.length === 0 ? (
              <tr>
                <td colSpan="5">لا يوجد زبائن حاليا</td>
              </tr>
            ) : (
              paginatedCustomers.map((customer, index) => (
                <tr key={index}>
                  <td className="text-wrap">{customer.name}</td>
                  <td className="text-wrap d-none d-md-table-cell">
                    {customer.phone}
                  </td>
                  <td>{customer.last_purchase_date}</td>
                  <td className="text-wrap d-none d-md-table-cell">
                    {customer.total_purchase_value}
                  </td>
                  <td>
                    <Link
                      to={`/customer/${customer.id}/`}
                      className="btn mx-1 bg-info text-white"
                     
                    >
                      <i className="far fa-eye"></i>
                    </Link>

                    <button
                      className="btn mx-1 bg-warning text-white"
                      onClick={() => handleEdit(customer)}
                      
                    >
                      <i className="fas fa-edit"></i>
                    </button>
                    <AlertModal
                      customebutton={
                        <button 
                          className="btn mx-1 bg-danger text-white"
                          style={{ backgroundColor: "darkgreen", color: "white" }}
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      }
                      title="حذف الزبون"
                      message="هل أنت متأكد من حذف هذا الزبون ؟"
                      myaction={() => handleDelete(customer.id)}
                      savetitle="حذف"
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div className="d-flex justify-content-between align-items-center flex-wrap mt-3">
        <button
          className="btn"
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
          style={{ 
            backgroundColor: currentPage === 1 ? "lightgray" : "darkgreen", 
            color: "white" 
          }}
        >
          الصفحة السابقة
        </button>
        <span className="mb-2" style={{ color: "darkgreen" }}>
          الصفحة {currentPage} من {totalPages}
        </span>
        <button
          className="btn"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
          style={{ 
            backgroundColor: currentPage === totalPages ? "lightgray" : "darkgreen", 
            color: "white" 
          }}
        >
          الصفحة التالية
        </button>
      </div>

      <CustomerModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        mode={modalMode}
        customerData={selectedCustomer}
        refreshData={fetchCustomers}
      />
    </div>
  );
};

export default CustomersListScreen;